var exports = {
  "i3": "referencesContainer__X3sMIX",
  "dE": "referencesListImmersiveContainer__qxukwS",
  "DD": "title__00Yyy-",
  "_B": "assistiveTitle__xsInA0",
  "fA": "referencesDetails__Z1tawj",
  "Ey": "referenceTokensOuterContainer__SeLYnP",
  "Np": "referenceTokensContainer__aJAe1D",
  "WM": "chatMessageReferenceListFooter__D3i_nx",
  "br": "chevronDownIcon__A9YU7B",
  "mA": "chevronUpIcon__BWdK66",
  "lF": "ActionList__qug1Z3",
};

module.exports = exports;
